import React from 'react';
import Layout from '@common/layouts';
import Leaderboard from '@common/components/leaderboard/Leaderboard';

const LeaderboardsPage = () => (
  <Leaderboard
    header="Mastered Units Leaderboard"
    studentDashboards={[
      'Leaderboard Student - Units Mastered by Subject Visual',
      'Leaderboard Student - Units Mastered Graph',
    ]}
    nonStudentDashboards={['Leaderboard Non-student Units Mastered']}
  />
);

LeaderboardsPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>;
};

export default LeaderboardsPage;
